import { CustomFlowbiteTheme } from 'flowbite-react';

export const badgeTheme: CustomFlowbiteTheme['badge'] = {
    root: {
        base: 'flex h-fit w-fit items-center gap-1 font-semibold font-sans !rounded-md', // rounded-full by default
        color: {
            primary:
                'bg-system-surface-container text-system-on-surface group-hover:primary-hover-state hover:primary-hover-state active:primary-active-state',
            error: 'bg-system-error text-system-on-error group-hover:primary-hover-state hover:primary-hover-state active:primary-active-state',
            warning:
                'bg-system-warning-container text-system-on-warning-container group-hover:secondary-hover-state hover:secondary-hover-state active:secondary-active-state',
            success:
                'bg-system-success text-system-on-success group-hover:secondary-hover-state hover:secondary-hover-state active:secondary-active-state',
            secondary:
                'bg-system-secondary text-system-on-secondary group-hover:secondary-hover-state hover:secondary-hover-state active:secondary-active-state',
            information:
                'bg-system-information text-system-on-information group-hover:secondary-hover-state hover:secondary-hover-state active:secondary-active-state',
        },
        href: 'group',
        size: {
            xs: 'p-1',
            sm: 'p-1.5',
            md: 'p-1.5',
        },
    },
    icon: {
        off: 'rounded px-2 py-0.5',
        on: 'rounded-full p-1.5',
        size: {
            // following values from iconLoader
            sm: 'w-4 h-4', // 16px
            md: 'w-6 h-6', // 24px (default)
            lg: 'w-8 h-8', // 32px
        },
    },
};

// Compact status-badge variant (e.g. the planner's DRAFT badge): 16px tall, 4px radius,
// uppercase label. Expressed as a theme so it wins deterministically over the slot
// classes flowbite's Badge applies (root.size padding, icon.on pill radius) instead of
// fighting them with !important utilities.
export const compactBadgeTheme: CustomFlowbiteTheme['badge'] = {
    ...badgeTheme,
    root: {
        ...badgeTheme.root,
        base: 'flex h-4 w-fit shrink-0 items-center gap-1 whitespace-nowrap uppercase font-medium font-sans rounded',
        size: {
            xs: 'px-1 py-0',
            sm: 'px-1 py-0',
            md: 'px-1 py-0',
        },
    },
    icon: {
        ...badgeTheme.icon,
        off: 'rounded px-1 py-0',
        on: 'rounded px-1 py-0',
    },
};
